import { CircleAlert } from 'lucide-react';

export function Status() {
  return (
    <div className='content'>
        <div className='content-liveness'>
            <div className='header'>Validação</div>

            <div className='content-success'>
                <CircleAlert color='#363636' strokeWidth={2} size={150}/>
                <span>Este link não está mais válido. É necessária a geração de um novo link.</span>
            </div>
        </div>
    </div>
  );
}